"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = require("./common");

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelidate/lib/validators/minLength.js
// module id = 2497
// module chunks = 1 6 12 13 15 16 36 37 40 41 42 43 45 48 53 55 56 57 58 59 60